<template>
    <section>
        <div v-bind:id="'comment' + comment.id" class="card shadow-sm mb-3" v-bind:class="{'border-success': comment.isSolving, ' border-0': !comment.isSolving}">
            <div class="card-body">
                <div class="row align-items-center">
                    <div class="col-auto" v-if="comment.user">
                        <h4 class="font-weight-medium mb-0">
                            {{ comment.user.name }}
                            <small class="text-muted">{{ listRoles(comment.user) }}</small>
                        </h4>
                    </div>
                    <div class="col-auto ml-auto">
                        <h5 class="text-muted mb-0">
                            Dibuat Tanggal: {{ [comment.createdAt, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY - HH:mm") }}
                        </h5>
                    </div>
                    <div class="col-auto" v-if="roleElligibleModified(comment) || roleElligibleSolve">
                        <ul class="navbar-nav dropdown-right ml-auto">
                            <b-nav-item-dropdown right no-caret>
                                <template slot="button-content">
                                    <i class="fa fa-ellipsis-v"></i>
                                </template>
                                <template v-if="roleElligibleModified(comment)">
                                    <b-dropdown-item v-bind:to="{ name: 'forum/thread/comment/edit', params: {id: comment.id} }">
                                        Edit Post
                                    </b-dropdown-item>
                                    <b-dropdown-item v-on:click="$emit('remove', comment)">
                                        Hapus Post
                                    </b-dropdown-item>
                                </template>
                                <b-dropdown-item v-on:click="$emit('solve', comment)" v-if="roleElligibleSolve">
                                    Tandai Sebagai Solusi
                                </b-dropdown-item>
                            </b-nav-item-dropdown>
                        </ul>
                    </div>
                    <hr class="w-100" />
                </div>
                <div class="row">
                    <div class="col-12" v-if="comment.quoted">
                        <blockquote class="blockquote rounded">
                            <div v-html="comment.quoted.content"></div>
                            <footer class="blockquote-footer font-weight-medium d-inline-block h4 text-dark">
                                {{ comment.quoted.user.name }}
                                <small class="text-muted">{{ listRoles(comment.quoted.user) }}</small>
                            </footer>
                        </blockquote>
                    </div>
                    <div class="col-12" v-html="comment.content"></div>
                    <hr class="w-100" />
                </div>
                <div class="row">
                    <div class="col-auto" v-if="comment.updatedAt">
                        <h5 class="text-muted mb-0">
                            Diedit Tanggal: {{ [comment.updatedAt, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY - HH:mm") }}
                        </h5>
                    </div>
                    <div class="col-auto ml-auto" v-if="roleElligibleReply()">
                        <a href="#reply" v-on:click="$emit('quote', comment)" class="btn btn-outline-danger btn-sm px-4" v-bind:class="{active: quoteComment.id === comment.id}">
                            Balas
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    /**
     * @param {Object} comment
     */
    export default {
        name: "ForumCommentItem",
        props: ['comment', 'quoteComment', 'listRoles', 'roleElligibleReply', 'roleElligibleModified', 'roleElligibleSolve'],
        computed: mapState([
            'profile'
        ])
    };
</script>

<style scoped>
    .navbar-nav >>> .nav-link { padding: 0rem 1rem; }
</style>


// WEBPACK FOOTER //
// src/components/forum/thread/item/Comment.vue